"use strict";
/*
 * @license
 * Copyright (c) 2019 Cristian Abrante. All rights reserved.
 * Licensed under the MIT License. See LICENSE in the project root for license information.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MutationBase =
/** @class */
function () {
  function MutationBase() {}

  MutationBase.prototype.mutateWith = function (individual, params) {
    var _this = this;

    individual.forEach(function (gene, index) {
      _this.mutateGene(individual, index, params);
    });
  };

  return MutationBase;
}();

exports.default = MutationBase;